/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import template from './report-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserProfile} from '../../components/session/local-user-profile';

@Component({
  standalone: false,
  selector: 'adn-report-list-page',
  template
})
export class ReportListPageComponent extends AdminResourceListPageBase implements OnInit {
  readonly itemStateName = 'app.rep.reports';

  showExecTime = false;
  columns: AdminListColumn[] = [
    {param: 'name'},
    {label: 'reportTemplate', param: '', sortable: false},
    {param: 'status'},
    {param: 'executionStartTime'},
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserProfile) private localUserProfile: any
  ) {
    super(LocalNetworkProfile);
  }

  ngOnInit(): void {
    super.ngOnInit();
    const username = this.localUserProfile.get('username');
    this.showExecTime = username === 'adnuntius@adnuntius.com' || username === 'broker1@adnuntius.com';
    if (this.showExecTime) {
      this.columns = [...this.columns, {label: 'execTime', param: '', sortable: false}];
    }
  }

}
